import { render, staticRenderFns } from "./FilterSelector.vue?vue&type=template&id=5d1b157c&scoped=true&"
import script from "./FilterSelector.vue?vue&type=script&lang=js&"
export * from "./FilterSelector.vue?vue&type=script&lang=js&"
import style0 from "./FilterSelector.vue?vue&type=style&index=0&id=5d1b157c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d1b157c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
